import { useDispatch, useSelector } from 'react-redux';

import { Link } from 'react-router-dom';
import { useBrowsingWorkspaceRoutes } from 'v5/core/app-scope/useBrowsingWorkspaceRoutes';
import { myServices } from 'v5/services/services.connected.app';

import { get } from 'lodash';
import _get from 'lodash/get';
import {
  createBooking,
  updateBooking
} from 'store/v1/bookings/bookings.actions';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from 'v5/design-system/Dialog';
import { Button, buttonVariants } from 'v5/design-system/Button';

/*

INSTRUCTIONS FOR USE
====

As with other modals, pass in an object as the second parameter of openModal to supply the data.
eg: openModal('BookingConflictModal', { method })

ALLOWED PROPERTIES:
⭐️ method 'CREATE' OR 'UPDATE' - state whether the action was a 'CREATE' or an 'UPDATE'
⭐️ resourceId int - The id of the resource to create a booking for. This will provide a link for the user to navigate to that resources calendar.

*/

const BookingConflictModal = ({ onRequestClose }) => {
  const dispatch = useDispatch();
  const ui = useSelector(state => state.ui);
  const resourceId = _get(ui, 'data.resourceId', '');
  const error = useSelector(state => state.bookings.error);
  const booking = get(error, 'booking', null);
  const routes = useBrowsingWorkspaceRoutes(myServices);

  if (!booking) return null;

  const handleForceCreate = () => {
    if (booking) {
      const newBooking = {
        ...booking,
        force: true
      };
      const action = booking.id
        ? updateBooking(booking.id, newBooking)
        : createBooking(newBooking);
      dispatch(action);
    }
    onRequestClose();
  };

  return (
    <Dialog open={!!booking} onOpenChange={c => !c && onRequestClose()}>
      <DialogContent className="max-w-min">
        <DialogHeader>
          <DialogTitle>
            <img
              src="/images/icon_colour_event_conflict.svg"
              alt="Booking conflict"
            />
            Booking conflict
          </DialogTitle>
        </DialogHeader>
        <DialogBody>
          We have found an existing booking that overlaps the one you are trying
          to {booking.id ? 'update' : 'create'}. You can continue to{' '}
          {booking.id ? 'update' : 'create'} this booking or view the
          conflicting booking within the resource calendar.
        </DialogBody>
        <DialogFooter>
          <Link
            to={
              resourceId
                ? routes.contacts.detail(resourceId)
                : routes.calendar.resources.home()
            }
            className={buttonVariants({ variant: 'ghost' })}
            target="_blank"
          >
            View resource calendar
          </Link>
          <Button variant="primaryAlt" onClick={handleForceCreate}>
            {booking.id ? 'Update' : 'Create'} booking anyway
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BookingConflictModal;

BookingConflictModal.isV5 = true;
